import ChatWidget from './components/ChatWidget';

export default function Home() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{
        background: 'linear-gradient(135deg, #FDF6F0 0%, #FAF0F4 60%, #FDF2F8 100%)',
        fontFamily: 'Poppins, Inter, sans-serif',
      }}
    >
      {/* Soft background blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-pink-100 rounded-full opacity-40 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-rose-100 rounded-full opacity-40 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-fuchsia-50 rounded-full opacity-50 blur-3xl" />
      </div>

      {/* Center content */}
      <div className="relative z-10 text-center max-w-md">
        <img
          src="https://static.readdy.ai/image/22602f61db723d886df2ffcff534fda8/4728923fdc166275b7926e4817bf6e64.png"
          alt="Bozzetti Store"
          className="h-20 object-contain mx-auto mb-6"
        />
        <h1 className="text-2xl font-bold text-gray-800 mb-3">Bem-vinda à Bozzetti Store</h1>
        <p className="text-gray-500 text-sm leading-relaxed">
          Clique na bolinha no canto inferior direito para iniciar uma conversa e descobrir nossas coleções de atacado e varejo.
        </p>
        <div className="flex items-center justify-center gap-2 mt-6 text-sm text-gray-400">
          <i className="ri-arrow-right-down-line text-lg" />
          <span>Clique no ícone abaixo</span>
        </div>
      </div>

      {/* Floating Chat Widget */}
      <ChatWidget />
    </div>
  );
}
